/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { BsPlayFill } from "react-icons/bs";
import { FaShieldAlt } from "react-icons/fa";
import { useRecoilValue } from "recoil";
import { InternalUserAtom, UserAtom } from "../atoms/UserAtom";
import useMediaQuery from "../hook/useMediaQuery";
import { HelpVideoNameMap } from "../types/HelpVideosTypes";
import { HelpVideo } from "./HelpVideo";
import { useModal } from "./Modal/Modal";

const Popover = styled.div`
  position: absolute;
  z-index: 999;
  height: fit-content;
  width: 200px;
  border-radius: 5px;
  box-shadow: 0px 3px 6px #00000026;
  display: flex;
  flex-direction: column;
  padding: 20px;
  left: 0px;
  top: 42px;
  background-color: #fff;

  > div {
    margin-bottom: 10px;
  }
`;

const PopRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px;

  :hover {
    opacity: 0.8;
  }
  :last-child {
    margin-bottom: 0;
  }
`;

const PlayButton = styled.div`
  min-width: 42px;
  max-width: 42px;
  min-height: 42px;
  max-height: 42px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border-radius: 5px;
  border: 1px solid #dddddd;

  cursor: pointer;

  position: relative;

  svg {
    width: 20px;
    height: 20px;

    color: #555555;
  }
`;

interface Props {
  contextTag: string;
  urlForPreview?: string;
}

export default function PlayVideoPopover(props: Props) {
  const { contextTag, urlForPreview } = props;
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const modal = useModal();
  const internalUser = useRecoilValue(InternalUserAtom);
  const user = useRecoilValue(UserAtom);
  const isLargerThan600 = useMediaQuery("(min-width: 600px)");

  /**
   * Temporary code to allow only Troy's accounts to use this.
   * It's better to have a phone in the source code than UIDs
   */

  if (!isLargerThan600) return <div></div>;

  return (
    <PlayButton
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <BsPlayFill size={20} />
      {open && (
        <Popover>
          <PopRow
            css={css`
              p {
                margin: 0;
                padding-left: 9px;
              }
            `}
            onClick={() =>
              modal.pushModal(
                <HelpVideo
                  urlForPreview={urlForPreview}
                  contextTag={contextTag}
                />,
                `${HelpVideoNameMap[contextTag]}`
              )
            }
          >
            <BsPlayFill
              css={css`
                margin-right: 2px;
              `}
              size={20}
            />
            <p>Watch Help Video</p>
          </PopRow>
          {!(
            (user &&
              !["5511966401241", "14343730297", "14074320801"].includes(
                user.phone
              )) ||
            (internalUser &&
              !["5511966401241", "14343730297", "14074320801"].includes(
                internalUser.phone
              ))
          ) && (
            <PopRow
              css={css`
                p {
                  margin: 0;
                  padding-left: 5px;
                }
              `}
              onClick={() => router.push("/armory")}
            >
              <FaShieldAlt
                css={css`
                  margin-right: 5px;
                  margin-left: 2px;
                `}
                size={15}
              />
              <p>Visit Armory</p>
            </PopRow>
          )}
        </Popover>
      )}
    </PlayButton>
  );
}
